import {generatorImageByDiv} from '../utils/createTextImg';
import {BASE_HEIGHT} from '../config';
import {DEFAULT_TEXT_NAME} from '../components/Index/DigitalAnchor/ResourceLib/config';

export const transTextbox = (item) => {
    try {
        const {y, h, url} = item;
        let {
            distanceToTop
        } = generatorImageByDiv(item);

        if (!distanceToTop || !y || !h || !url) {
            return item;
        }

        distanceToTop = distanceToTop - 1;

        const transY = distanceToTop / BASE_HEIGHT;

        const newY = Number(y) + transY;
        const newH = Number(h) - transY * 2;
        const realHeight = (h * BASE_HEIGHT * 3).toFixed(0);
        const clipHeight = (distanceToTop * 3).toFixed(0);

        const realUrl = url?.split('?')[0];
        const newUrl = `${realUrl}?x-bce-process=image/crop,y_${Math.max(clipHeight, 0)},h_${Math.max(realHeight - 2 * clipHeight, 1)}`;

        return {
            ...item,
            url: newUrl,
            h: newH,
            y: newY,
            genderTime: new Date().getTime()
        };
    }
    catch (e) {
        return item;
    }
};

export const transElementsTextbox = (elements = []) => {
    try {
        return elements.map(item => {
            if (item.type === 'txt' && item.name !== DEFAULT_TEXT_NAME && !item.genderTime) {
                return transTextbox(item);
            }
            return item;
        });
    }
    catch (e) {
        return elements;
    }
};
